import React, { Component, useEffect, useState } from "react";
import ComponentDonationMobile from "./ComponentDonationMobile";
import ComponentDonationWeb from "./ComponentDonationWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentDonation = () => {
  const gaEventTracker = useAnalyticsEventTracker("Donation");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Donation",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentDonationWeb></ComponentDonationWeb>
      </BrowserView>
      <MobileView>
        <ComponentDonationMobile></ComponentDonationMobile>
      </MobileView>
    </>
  );
};

export default ComponentDonation;
